window.$ = require('jquery');

$(document).ready(function () {
    var trackedVideos = new WeakSet();

    function initVideoTracking(video) {
        if (!video || trackedVideos.has(video)) return;

        try {
            var videoURL = video.src || (video.querySelector('source') ? video.querySelector('source').src : '');
            if (!videoURL) return;

            var videoTitle = videoURL.split('/').pop() || 'unknown_video';
            var videoDuration = null;
            var completedFired = false;

            video.addEventListener('loadedmetadata', function () {
                try {
                    videoDuration = Math.floor(video.duration) || 0;
                } catch (err) {
                    videoDuration = 0;
                }
            });

            function pushToDataLayer(eventName) {
                try {
                    window.dataLayer = window.dataLayer || [];
                    var duration = videoDuration || Math.floor(video.duration) || 0;

                    window.dataLayer.push({
                        event: eventName,
                        video_duration: duration,
                        video_title: videoTitle,
                        video_url: videoURL
                    });
                } catch (err) {}
            }

            video.addEventListener('play', function () {
                completedFired = false;
                pushToDataLayer('video_start');
            });

            video.addEventListener('pause', function () {
                if (!video.ended) pushToDataLayer('video_pause');
            });

            // ENDED
            video.addEventListener('ended', function () {
                if (!completedFired) {
                    completedFired = true;
                    pushToDataLayer('video_complete');
                }
            });

            // NEW: Progress listener to ensure completion triggers if ended doesn't fire
            video.addEventListener('timeupdate', function () {
                try {
                    if (!video.duration || completedFired) return;
                    var progress = video.currentTime / video.duration;
                    if (progress >= 0.99) {
                        completedFired = true;
                        pushToDataLayer('video_complete');
                    }
                } catch (err) {}
            });

            trackedVideos.add(video);
        } catch (err) {}
    }

    function scanAndInitVideos() {
        try {
            var videos = document.querySelectorAll('video');
            if (!videos || !videos.length) return;
            videos.forEach(initVideoTracking);
        } catch (err) {}
    }

    scanAndInitVideos();
    setTimeout(scanAndInitVideos, 2000);

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.tagName === 'VIDEO') {
                    initVideoTracking(node);
                } else if (node.querySelectorAll) {
                    node.querySelectorAll('video').forEach(initVideoTracking);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});